module.exports = __webpack_public_path__ + "static/media/icon-email.64dcc8ae.svg";